// src/components/BankVerificationAllocationToAssociate.js
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Paper,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Tabs,
  Tab,
  Button,
  IconButton
} from "@mui/material";
import { Visibility, Sync, ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import api from "./api/apiClient";
import moment from "moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const BankVerificationAllocationToAssociate = () => {
  const [unallocated, setUnallocated] = useState([]);
  const [allocated, setAllocated] = useState([]);
  const [completed, setCompleted] = useState([]);
  const [requested, setRequested] = useState([]);
  const [scheduled, setScheduled] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [associateList, setAssociateList] = useState([]);
  const [selectedAssociate, setSelectedAssociate] = useState("");
  const [tabIndex, setTabIndex] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    fetchBankVerifications();
    fetchAssociates();
  }, []);

  const fetchBankVerifications = async () => {
    try {
      const res = await api.get("/bankverifications");
      console.log("Response is ",res);
      const u = [];
      const a = [];
      const c = [];
      const r = [];
      const s = [];

      res.data.forEach((item) => {
        if (!item.allocatedToAssociate) {
          u.push(item);
        } else if (
          item.status?.trim().toUpperCase() === "ALLOCATED"
        ) {
          a.push(item);
        } else if (item.status?.trim().toUpperCase() === "COMPLETED") {
          c.push(item);
        } else if (
          item.status?.trim().toUpperCase() === "REQUESTED" 
        ) {
          r.push(item);
        } else if (item.status?.trim().toUpperCase() === "SCHEDULED"
        ) 
          s.push(item);
        }
      );

      setUnallocated(u);
      setAllocated(a);
      setCompleted(c);
      setScheduled(s);
      setRequested(r);
    } catch (err) {
      console.error("Error fetching bank verifications", err);
    }
  };

  const fetchAssociates = async () => {
    try {
      const userId = localStorage.getItem("userId");
      const res = await api.get(`/users/reportees/${userId}`);
      setAssociateList(res.data);
    } catch (err) {
      console.error("Error fetching associates", err);
    }
  };
  const getAssociateName = (associateId)=>{
    for(let i=0; i < associateList.length;i++){
      let item = associateList[i];
      if(item.id === associateId){
        console.log("Returning name ",item.name);
        return item.name;
      }      
    }

  }  
  const handleSelectToggle = (item) => {
    const exists = selectedItems.some((c) => c.id === item.id);
    if (exists) {
      setSelectedItems((prev) => prev.filter((c) => c.id !== item.id));
    } else {
      setSelectedItems((prev) => [...prev, item]);
    }
  };

  const handleTabChange = (e, newVal) => {
    setTabIndex(newVal);
    setSelectedItems([]);
  };

  const handleAllocate = async () => {
    try {
      await api.put(
        `/bankverifications/assigntoassociate/${selectedAssociate}`,
        selectedItems
      );
      await fetchBankVerifications();
      setSelectedItems([]);
    } catch (err) {
      console.error("Error allocating bank verifications", err);
    }
  };

  const handleBack = () => {
    navigate(-1);
  };
  const handleExportToExcel = () => {
    let dataToExport = [];
    let tabName = "";
  
    if (tabIndex === 0) {
      dataToExport = unallocated;
      tabName = "Unallocated";
    } else if (tabIndex === 1) {
      dataToExport = allocated;
      tabName = "Allocated";
    } else if (tabIndex === 2) {
      dataToExport = completed;
      tabName = "Completed";
    } else if (tabIndex === 3) {
      dataToExport = requested;
      tabName = "Meeting Request Sent";
    } else if (tabIndex === 4) {
      dataToExport = scheduled;
      tabName = "Meeting Scheduled";
    }
  
    if (!dataToExport.length) {
      alert("No data to export for this tab.");
      return;
    }
  
    // Format the data (remove nested objects)
    const formattedData = dataToExport.map(item => ({
      "VB Number": item.caseId,
      "Check ID": item.checkId,
      "Client Name": item.clientName,
      "Candidate Name": item.candidateName,
      "Emp Type": item.empType,
      "Company Name": item.companyName,
      "Mobile Phone Number": item.mobilePhoneNumber,
      "Email": item.email,
      "Tenure From": item.tenureFrom ? moment(item.tenureFrom).format("DD-MMM-YYYY") : "",
      "Tenure To": item.tenureTo ? moment(item.tenureTo).format("DD-MMM-YYYY") : "",
      "Assigned By Emp Exec": item.assignedByEmpExec,
      "BS Init. Date": item.bsInitiationDate ? moment(item.bsInitiationDate).format("DD-MMM-YYYY") : "",
      "Status": item.status,
      "Allocation Date": item.dateOfAllocationToAssociate
        ? moment(item.dateOfAllocationToAssociate).format("DD-MMM-YYYY")
        : ""
    }));
  
    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, tabName);
  
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  
    saveAs(blob, `BankVerification_${tabName}_${moment().format("YYYYMMDD_HHmm")}.xlsx`);
  };
  const renderTable = (data) => (
    <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell>VB Number</TableCell>
            <TableCell>Check ID</TableCell>
            <TableCell>Client Name</TableCell>
            <TableCell>Candidate Name</TableCell>
            <TableCell>Emp Type</TableCell>
            <TableCell>Company Name</TableCell>            
            <TableCell>Mobile Phone Number</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Tenure From</TableCell>
            <TableCell>Tenure To</TableCell>
            <TableCell>Assigned By Emp Exec</TableCell>
            <TableCell>BS Init. Date.</TableCell>                        
            <TableCell>Status</TableCell>
            <TableCell>Allocated To Associate</TableCell>              
            <TableCell>Allocation Date</TableCell>                          
            <TableCell>Remarks</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item) => (
            <TableRow key={item.id} hover>
              <TableCell padding="checkbox">
                <Checkbox
                  checked={selectedItems.some((c) => c.id === item.id)}
                  onChange={() => handleSelectToggle(item)}
                />
              </TableCell>
              <TableCell>{item.caseId}</TableCell>
              <TableCell>{item.checkId}</TableCell>
              <TableCell>{item.clientName}</TableCell>
              <TableCell>{item.candidateName}</TableCell>
              <TableCell>{item.employmentType}</TableCell>
              <TableCell>{item.companyName}</TableCell>              
              <TableCell>{item.mobilePhoneNumber}</TableCell>
              <TableCell>{item.email}</TableCell>
              <TableCell>
                {item.tenureFrom
                  ? moment(item.tenureFrom).format("DD-MMM-YYYY")
                  : ""}
              </TableCell>
              <TableCell>
                {item.tenureTo
                  ? moment(item.tenureTo).format("DD-MMM-YYYY")
                  : ""}
              </TableCell>
              <TableCell>{item.assignedByEmpExec}</TableCell>
              <TableCell>
                {item.tenureFrom
                  ? moment(item.bsInitiationDate).format("DD-MMM-YYYY")
                  : ""}
              </TableCell>
              <TableCell>{item.status}</TableCell>
              <TableCell>{getAssociateName(item.allocatedToAssociate)}</TableCell>              
              <TableCell>{item.dateOfAllocationToAssociate
                      ? moment(item.dateOfAllocationToAssociate).format("DD-MMM-YYYY")
                      : ""}
              </TableCell>              
              <TableCell>{item.remarks}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const isButtonDisabled = selectedItems.length === 0 || !selectedAssociate;

  return (
    <Box sx={{ width: "95%", margin: "auto", mt: 4 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <IconButton onClick={handleBack}>
            <ArrowBack />
          </IconButton>
          <Typography variant="h5" sx={{ fontWeight: "bold", ml: 1 }}>
            Bank Verification Allocation to Associate
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Button
            variant="contained"
            color="success"
            size="small"
            onClick={handleExportToExcel}
          >
            Export to Excel
          </Button>
          <IconButton onClick={fetchBankVerifications}><Sync /></IconButton>
        </Box>
      </Box>

      <Tabs value={tabIndex} onChange={handleTabChange} sx={{ mb: 2 }}>
        <Tab
          label={`Unallocated${
            unallocated.length > 0 ? ` (${unallocated.length})` : ""
          }`}
        />
        <Tab
          label={`Allocated${
            allocated.length > 0 ? ` (${allocated.length})` : ""
          }`}
        />
        <Tab
          label={`Completed${
            completed.length > 0 ? ` (${completed.length})` : ""
          }`}
        />
        <Tab
          label={`Meeting Request Sent${
            requested.length > 0 ? ` (${requested.length})` : ""
          }`}
        />
        <Tab
          label={`Meeting Scheduled${
            scheduled.length > 0 ? ` (${scheduled.length})` : ""
          }`}
        />
      </Tabs>

      {tabIndex === 0 && renderTable(unallocated)}
      {tabIndex === 1 && renderTable(allocated)}
      {tabIndex === 2 && renderTable(completed)}
      {tabIndex === 3 && renderTable(requested)}
      {tabIndex === 4 && renderTable(scheduled)}

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 3
        }}
      >
        <FormControl sx={{ minWidth: 200 }}>
          <InputLabel id="associate-select-label">Select Associate</InputLabel>
          <Select
            labelId="associate-select-label"
            value={selectedAssociate}
            onChange={(e) => setSelectedAssociate(e.target.value)}
          >
            {associateList.map((a) => (
              <MenuItem key={a.id} value={a.id}>
                {a.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {(tabIndex === 0 || tabIndex === 1) && (
          <Button
            variant="contained"
            color="primary"
            disabled={isButtonDisabled}
            onClick={handleAllocate}
          >
            {tabIndex === 0 ? "Allocate" : "Re-Allocate"}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default BankVerificationAllocationToAssociate;
